import { Controller } from "@hotwired/stimulus";

// The back-to-top button. Far down a page (more than three screens) it
// jumps straight to the top: smoothly scrolling a long magazine would draw
// every PDF page on the way and can stall. Nearby, or with reduced motion
// off, it scrolls smoothly. Focus moves to the page's heading, so keyboard
// users land at the top too; the address isn't changed.
export default class extends Controller {
  scroll(event) {
    event.preventDefault();
    const far = window.scrollY > window.innerHeight * 3;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: far || reduceMotion ? "instant" : "smooth" });

    const heading = document.querySelector("main h1");
    if (heading) {
      if (!heading.hasAttribute("tabindex")) heading.setAttribute("tabindex", "-1");
      heading.focus({ preventScroll: true });
    }
  }
}
